<template>

  <Modal v-if="value" :value="value" :with-footer="false" @input="close">
    <p slot="header">Guarde o secret do webhook</p>

    <div class="row">
      <div class="col-md-12">
        <p>
          Este valor <strong>não será exibido novamente</strong>. Use ele para conferir a assinatura
          <strong>X-Brobot-Signature</strong> das requisições que enviarmos.
        </p>

        <div class="d-flex align-items-center mb-3">
          <code class="mr-3">{{ secret }}</code>

          <CopyIcon
            @click="copy"
            class="fd-icon"
            size="1.2x"
            style="cursor: pointer"
            v-tooltip.bottom="{ content: tooltip }"
          />
        </div>

        <div class="text-right">
          <button class="btn btn-primary" @click="close">Já guardei</button>
        </div>
      </div>
    </div>

  </Modal>

</template>

<script>
  import Modal from '@/components/shares/specialTag/Modal'
  import { CopyIcon } from 'vue-feather-icons'

  export default {
    components: { CopyIcon, Modal },
    data() {
      return {
        tooltip: 'Clique para copiar'
      }
    },
    methods: {
      close() {
        this.$emit('input', false)
      },
      copy() {
        navigator.clipboard.writeText(this.secret)
          .then(() => {
            this.tooltip = 'Secret copiado!'
            setTimeout(() => this.tooltip = 'Clique para copiar', 2000)
          })
          .catch(() => this.$notify.addError('Erro ao copiar o secret'))
      }
    },
    name: 'WebhookSecretModal',
    props: {
      secret: { default: '', type: String },
      value: { default: false, type: Boolean }
    }
  }
</script>

<style scoped>
</style>
